import React from "react";
import "./style.css";

function CoverPathMass() {
  return (
    <iframe
      src="https://coverpath.massmutual.com//?fg=Evan-Cleary-621160"
      height="960"
      width="1200`"
      title="Coverpath"
    ></iframe>
  );
}

export default CoverPathMass;
